<parkour-picture [sources]="sources" [alt]="alt" />
